import isUndefined from "lodash/isUndefined";
import React, { memo, useCallback } from "react";
import locale from "./boolWidget.locale";
import Styled from "./boolWidget.styled";
function BoolWidget({ className, value, onChange, size, fieldName, ...other }) {
    const handleChange = useCallback((val) => {
        onChange && onChange(val, fieldName);
    }, [onChange, fieldName]);
    return (React.createElement(Styled.Switch, { ...other, size: size, className: className, value: !isUndefined(value) ? Boolean(value) : undefined, onValueChange: onChange ? handleChange : undefined, switchedOffText: "", switchedOnText: "", focusStateEnabled: false, activeStateEnabled: false, hint: value ? locale.YES : locale.NO }));
}
export default memo(BoolWidget);
BoolWidget.defaultProps = {
    value: false,
    size: "md"
};
